const countries = [
  { code: "united-states-of-america", displayName: "United States" },
  { code: "mexico", displayName: "Mexico" },
];

const states = [
  // USA
  { countryCode: "united-states-of-america", code: "AL", displayName: "Alabama" },
  { countryCode: "united-states-of-america", code: "AK", displayName: "Alaska" },
  { countryCode: "united-states-of-america", code: "AZ", displayName: "Arizona" },
  { countryCode: "united-states-of-america", code: "AR", displayName: "Arkansas" },
  { countryCode: "united-states-of-america", code: "CA", displayName: "California" },
  { countryCode: "united-states-of-america", code: "CO", displayName: "Colorado" },
  { countryCode: "united-states-of-america", code: "CT", displayName: "Connecticut" },
  { countryCode: "united-states-of-america", code: "DE", displayName: "Delaware" },
  { countryCode: "united-states-of-america", code: "FL", displayName: "Florida" },
  { countryCode: "united-states-of-america", code: "GA", displayName: "Georgia" },
  { countryCode: "united-states-of-america", code: "HI", displayName: "Hawaii" },
  { countryCode: "united-states-of-america", code: "ID", displayName: "Idaho" },
  { countryCode: "united-states-of-america", code: "IL", displayName: "Illinois" },
  { countryCode: "united-states-of-america", code: "IN", displayName: "Indiana" },
  { countryCode: "united-states-of-america", code: "IA", displayName: "Iowa" },
  { countryCode: "united-states-of-america", code: "KS", displayName: "Kansas" },
  { countryCode: "united-states-of-america", code: "KY", displayName: "Kentucky" },
  { countryCode: "united-states-of-america", code: "LA", displayName: "Louisiana" },
  { countryCode: "united-states-of-america", code: "ME", displayName: "Maine" },
  { countryCode: "united-states-of-america", code: "MD", displayName: "Maryland" },
  { countryCode: "united-states-of-america", code: "MA", displayName: "Massachusetts" },
  { countryCode: "united-states-of-america", code: "MI", displayName: "Michigan" },
  { countryCode: "united-states-of-america", code: "MN", displayName: "Minnesota" },
  { countryCode: "united-states-of-america", code: "MS", displayName: "Mississippi" },
  { countryCode: "united-states-of-america", code: "MO", displayName: "Missouri" },
  { countryCode: "united-states-of-america", code: "MT", displayName: "Montana" },
  { countryCode: "united-states-of-america", code: "NE", displayName: "Nebraska" },
  { countryCode: "united-states-of-america", code: "NV", displayName: "Nevada" },
  { countryCode: "united-states-of-america", code: "NH", displayName: "New Hampshire" },
  { countryCode: "united-states-of-america", code: "NJ", displayName: "New Jersey" },
  { countryCode: "united-states-of-america", code: "NM", displayName: "New Mexico" },
  { countryCode: "united-states-of-america", code: "NY", displayName: "New York" },
  { countryCode: "united-states-of-america", code: "NC", displayName: "North Carolina" },
  { countryCode: "united-states-of-america", code: "ND", displayName: "North Dakota" },
  { countryCode: "united-states-of-america", code: "OH", displayName: "Ohio" },
  { countryCode: "united-states-of-america", code: "OK", displayName: "Oklahoma" },
  { countryCode: "united-states-of-america", code: "OR", displayName: "Oregon" },
  { countryCode: "united-states-of-america", code: "PA", displayName: "Pennsylvania" },
  { countryCode: "united-states-of-america", code: "RI", displayName: "Rhode Island" },
  { countryCode: "united-states-of-america", code: "SC", displayName: "South Carolina" },
  { countryCode: "united-states-of-america", code: "SD", displayName: "South Dakota" },
  { countryCode: "united-states-of-america", code: "TN", displayName: "Tennessee" },
  { countryCode: "united-states-of-america", code: "TX", displayName: "Texas" },
  { countryCode: "united-states-of-america", code: "UT", displayName: "Utah" },
  { countryCode: "united-states-of-america", code: "VT", displayName: "Vermont" },
  { countryCode: "united-states-of-america", code: "VA", displayName: "Virginia" },
  { countryCode: "united-states-of-america", code: "WA", displayName: "Washington" },
  { countryCode: "united-states-of-america", code: "WV", displayName: "West Virginia" },
  { countryCode: "united-states-of-america", code: "WI", displayName: "Wisconsin" },
  { countryCode: "united-states-of-america", code: "WY", displayName: "Wyoming" },
  // Mexico
  { countryCode: "mexico", code: "MX-AGU", displayName: "Aguascalientes" },
  { countryCode: "mexico", code: "MX-BCN", displayName: "Baja California" },
  { countryCode: "mexico", code: "MX-BCS", displayName: "Baja California Sur" },
  { countryCode: "mexico", code: "MX-CAM", displayName: "Campeche" },
  { countryCode: "mexico", code: "MX-CHP", displayName: "Chiapas" },
  { countryCode: "mexico", code: "MX-CHH", displayName: "Chihuahua" },
  { countryCode: "mexico", code: "MX-COA", displayName: "Coahuila de Zaragoza" },
  { countryCode: "mexico", code: "MX-COL", displayName: "Colima" },
  { countryCode: "mexico", code: "MX-DUR", displayName: "Durango" },
  { countryCode: "mexico", code: "MX-GUA", displayName: "Guanajuato" },
  { countryCode: "mexico", code: "MX-GRO", displayName: "Guerrero" },
  { countryCode: "mexico", code: "MX-HID", displayName: "Hidalgo" },
  { countryCode: "mexico", code: "MX-JAL", displayName: "Jalisco" },
  { countryCode: "mexico", code: "MX-MEX", displayName: "México" },
  { countryCode: "mexico", code: "MX-CMX", displayName: "Ciudad de México" },
  { countryCode: "mexico", code: "MX-MIC", displayName: "Michoacán de Ocampo" },
  { countryCode: "mexico", code: "MX-MOR", displayName: "Morelos" },
  { countryCode: "mexico", code: "MX-NAY", displayName: "Nayarit" },
  { countryCode: "mexico", code: "MX-NLE", displayName: "Nuevo León" },
  { countryCode: "mexico", code: "MX-OAX", displayName: "Oaxaca" },
  { countryCode: "mexico", code: "MX-PUE", displayName: "Puebla" },
  { countryCode: "mexico", code: "MX-QUE", displayName: "Querétaro de Arteaga" },
  { countryCode: "mexico", code: "MX-ROO", displayName: "Quintana Roo" },
  { countryCode: "mexico", code: "MX-SLP", displayName: "San Luis Potosí" },
  { countryCode: "mexico", code: "MX-SIN", displayName: "Sinaloa" },
  { countryCode: "mexico", code: "MX-SON", displayName: "Sonora" },
  { countryCode: "mexico", code: "MX-TAB", displayName: "Tabasco" },
  { countryCode: "mexico", code: "MX-TAM", displayName: "Tamaulipas" },
  { countryCode: "mexico", code: "MX-TLA", displayName: "Tlaxcala" },
  { countryCode: "mexico", code: "MX-VER", displayName: "Veracruz de Ignacio de la Llave" },
  { countryCode: "mexico", code: "MX-YUC", displayName: "Yucatán" },
  { countryCode: "mexico", code: "MX-ZAC", displayName: "Zacatecas" },
];

const languages = [
  { code: "en", displayName: "English" },
  { code: "es", displayName: "Spanish" },
];

const reportStatuses = [
  { code: "created", displayName: "Created" },
  { code: "sent-by-email", displayName: "Sent by email" },
  { code: "in-progress", displayName: "In Progress" },
  { code: "declined", displayName: "Declined" },
  { code: "completed", displayName: "Completed" },
];

const reportOverallScores = [
  { code: "none", displayName: "None", color: "" },
  { code: "above-conditions", displayName: "Above Conditions", color: "#3aaa67" },
  { code: "requires-clarification", displayName: "Requires Clarification", color: "#cccc4a" },
  { code: "below-conditions", displayName: "Below Conditions", color: "#cc4c56" },
  { code: "inconclusive", displayName: "Inconclusive", color: "#666666" },
  { code: "declined", displayName: "Declined Interview", color: "#CC6633" },
];

const reportStatusCause = [
  { code: "Completed", displayName: "completed", color: "" },
  { code: "Declined", displayName: "declined", color: "#CC6633" },
  { code: "Timeout", displayName: "timeout", color: "#198ECB" },
];

const reportPeriodicDecisions = [
  { code: "in_review", displayName: "In Review" },
  { code: "handled", displayName: "Handled" },
];

const reportPreEmploymentDecisions = [
  { code: "in_review", displayName: "In Review" },
  { code: "hire", displayName: "Hire" },
  { code: "decline", displayName: "Decline" },
];

const reportInvestigationDecisions = [
  { code: "in_review", displayName: "In Review" },
  { code: "handled", displayName: "Handled" },
];

const reportResponseEdits = [
  { code: "irrelevant", displayName: "Question is not relevant. Results will be updated." },
  { code: "reasonable-explanation-provided", displayName: "Reasonable explanation provided. Results will be updated." },
  { code: "confirmed", displayName: "Response confirmed, which places the score below conditions." },
  { code: "revert", displayName: "Clear the response edit. Results will be updated." },
];

const reportObservationEdits = [
  { code: "referred-for-follow-up", displayName: "Referred for follow up." },
  { code: "revert", displayName: "Clear the response edit. Results will be updated." },
];

const organizationScoring = [
  { code: "standard", displayName: "Standard" },
  { code: "pass-fail", displayName: "Pass/Fail" },
];

export default {
  strict: true,
  namespaced: true,
  getters: {
    countries: () => countries,
    states: () => states,
    languages: () => languages,
    reportStatuses: () => reportStatuses,
    reportOverallScores: () => reportOverallScores,
    reportStatusCause: () => reportStatusCause,
    reportPeriodicDecisions: () => reportPeriodicDecisions,
    reportPreEmploymentDecisions: () => reportPreEmploymentDecisions,
    reportInvestigationDecisions: () => reportInvestigationDecisions,
    reportResponseEdits: () => reportResponseEdits,
    reportObservationEdits: () => reportObservationEdits,
    organizationScoring: () => organizationScoring,
  },
};
